/**
 * Erlaubt es asynchrone Requests durchzuführen und dabei nur die Response weiterzuleiten,
 * die vom letzten Request stammt. Wird also während der Dauer eines Requests ein weiterer Request gestellt,
 * so wird die erste Antwort verworfen.
 * Optional kann im Konstruktor ein Disposable übergeben werden, welches beim Eintreffen der Response noch nicht disposed sein darf.
 *
 * Rückgabe ist stets ein Promise.
 *
 * Anwendungsbeispiele:
 * var acceptor = new LastResponseAcceptor(self);
 * var yes = ... Neuste-Response-erhalten-Callback ...; 
 * var no  = ... Alte-Response-verworfen-Callback ...;
 *
 * // Deferred/Promise-Variante (gibt ein Promise zurück)
 * acceptor.query($.ajax(...)).done(yes).fail(no);
 *
 * // Beliebige Requests (am Beispiel eines Ajax-Requests):
 * acceptor.query(function(resolveIfLast, reject) {
 *     asyncOperation(function(data) {
 *         if (data.isOk) {
 *             resolveIfLast(data);   // Äußeres Promise rejecten wenn schon neue Requests vorliegen, ansonsten resolven
 *         }
 *         else {
 *             reject("error"); // Äußeres Promise rejecten
 *         }
 *     });
 * }).done(yes).fail(no);
 * 
 * 
 * 
 */
export default class LastResponseAcceptor {

    private callId;

    constructor(private optionalDisposable?) {
        this.callId = 0;
    }

    public query(requester) {
        if (requester == null) {
            return null;
        }

        if (typeof requester === 'function') {
            return this._request(requester);
        }

        if (typeof requester.done === 'function' && typeof requester.fail === 'function') {
            return this._promise(requester);
        }

        return null;
    }

    public _promise(promise) {
        let myCallId = ++this.callId;

        let def = $.Deferred();

        let self = this;

        promise
            .fail(def.reject)   // Reject directly if given promise fails
            .done(function () {
                if (myCallId === self.callId && (self.optionalDisposable == null || self.optionalDisposable.isDisposed === false)) {
                    def.resolve.apply(def, arguments);   // Resolve if call is current and disposable is not disposed
                }
                else {
                    def.reject(null);                    // Reject if call is not current or disposable is disposed
                }
            });

        return def.promise();
    }

    public _request(performRequest) {
        let def = $.Deferred();

        performRequest(def.resolve, def.reject);

        return this._promise(def.promise());
    }
}